<template>
  <div :class="['relative', { 'ml-auto': !collapsed }]">
    <div v-if="collapsed" class="absolute -top-2.5 -left-2 h-2 w-2 rounded-full bg-blue-700" />
    <Badge v-else :value="count" tone="info" class="ml-auto" />
  </div>
</template>

<script setup lang="ts">
import { Badge } from '@boqnet/ui';

defineProps<{
  count: number;
  collapsed: boolean;
}>();
</script>
